import { TranslatedCalling } from './common';
import { ToolImagePreviewStrip } from './ToolImagePreviewStrip';

export const fetch_user_images = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-user-images.fetching" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-user-images.fetching" />,
  result: ({ result }: { result: unknown }) => <ToolImagePreviewStrip output={result} />,
};
